export const apiURL = process.env.NEXT_PUBLIC_APIURL;

export const pagesApiUrl = process.env.PAGESAPIURL;
export const pagesApiUrlFileExt = process.env.PAGESAPIURLFILEEXT || '';

export const menusApiUrl = process.env.MENUSAPIURL;
export const works = process.env.NEXT_PUBLIC_WORKS;

export const worksApiUrl = `${apiURL}${works}`;

// This value it's in seconds
export const freshDataInCache = process.env.VALID_DATA_IN_CACHE;

// This value it's in seconds
export const getNewDataToCache = process.env.TIME_TO_GET_NEW_DATA_TO_CACHE;
